// Shoptrendyfy Theme JavaScript
document.addEventListener('DOMContentLoaded', function() {
  initNavbar();
  initMobileMenu();
  initSearch();
  initWishlistButtons();
  initQuantitySelectors();
  initAccordions();
  initProductImageZoom();
  initAnimations();
  updateCartCount();
});

function initNavbar() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 20) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
}

function toggleMobileMenu() {
  document.getElementById('mobileMenu').classList.toggle('open');
  document.body.style.overflow = document.body.style.overflow === 'hidden' ? '' : 'hidden';
}

function toggleSearch() {
  const overlay = document.getElementById('searchOverlay');
  overlay.classList.toggle('open');
  if (overlay.classList.contains('open')) {
    setTimeout(function() {
      overlay.querySelector('.search-input').focus();
    }, 300);
  }
  document.body.style.overflow = overlay.classList.contains('open') ? 'hidden' : '';
}

function initMobileMenu() {
  const btn = document.querySelector('[data-mobile-menu-toggle]');
  if (btn) btn.addEventListener('click', toggleMobileMenu);
}

function initSearch() {
  const btn = document.querySelector('[data-search-toggle]');
  if (btn) btn.addEventListener('click', toggleSearch);
}

function toggleWishlist(btn, handle) {
  btn.classList.toggle('active');
  var svg = btn.querySelector('svg');
  if (btn.classList.contains('active')) {
    svg.setAttribute('fill', 'var(--forest)');
    svg.setAttribute('color', 'var(--forest)');
  } else {
    svg.removeAttribute('fill');
    svg.setAttribute('color', '');
  }
  var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  var idx = wishlist.indexOf(handle);
  if (idx > -1) wishlist.splice(idx, 1); else wishlist.push(handle);
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  updateWishlistCount();
}

function initWishlistButtons() {
  var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  document.querySelectorAll('.product-card-item [aria-label="Add to wishlist"]').forEach(function(btn) {
    var handle = btn.getAttribute('onclick');
    if (handle) {
      var match = handle.match(/'([^']+)'/);
      if (match && wishlist.indexOf(match[1]) > -1) {
        btn.classList.add('active');
        var svg = btn.querySelector('svg');
        if (svg) { svg.setAttribute('fill', 'var(--forest)'); svg.setAttribute('color', 'var(--forest)'); }
      }
    }
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var handleMatch = this.getAttribute('onclick').match(/'([^']+)'/);
      if (handleMatch) toggleWishlist(this, handleMatch[1]);
    });
  });
}

function initQuantitySelectors() {
  document.querySelectorAll('.quantity-selector').forEach(function(selector) {
    if (selector.closest('#cart-root')) return;
    var minus = selector.querySelector('.qty-minus');
    var plus = selector.querySelector('.qty-plus');
    var input = selector.querySelector('input');
    if (minus && input) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
        input.dispatchEvent(new Event('change'));
      });
    }
    if (plus && input) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });
}

function initAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var content = this.nextElementSibling;
      var isOpen = content.classList.contains('open');
      this.classList.toggle('open');
      content.classList.toggle('open');
    });
  });
}

function initProductImageZoom() {
  var mainImage = document.querySelector('.product-main-image');
  if (!mainImage) return;
  mainImage.addEventListener('mousemove', function(e) {
    var rect = this.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    var img = this.querySelector('img');
    if (img) {
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(1.5)';
    }
  });
  mainImage.addEventListener('mouseleave', function() {
    var img = this.querySelector('img');
    if (img) {
      img.style.transformOrigin = 'center center';
      img.style.transform = 'scale(1)';
    }
  });
}

function initAnimations() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-up');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.animate-on-scroll').forEach(function(el) {
    observer.observe(el);
  });
}

function updateCartCount() {
  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    var badges = document.querySelectorAll('[data-cart-count]');
    var count = cart.item_count || 0;
    badges.forEach(function(b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }).catch(function() {});
}

function updateWishlistCount() {
  var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  var count = wishlist.length;
  var badges = document.querySelectorAll('[data-wishlist-count]');
  badges.forEach(function(b) {
    b.textContent = count;
    b.style.display = count > 0 ? 'flex' : 'none';
  });
}

// Cart AJAX for Shopify
function addToCart(variantId, quantity) {
  var formData = { items: [{ id: variantId, quantity: quantity || 1 }] };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    var count = document.querySelector('[data-cart-count]');
    if (count) {
      var current = parseInt(count.textContent) || 0;
      count.textContent = current + (quantity || 1);
      count.style.display = 'flex';
    }
    showToast('Added to bag');
  })
  .catch(function(err) { console.error('Cart error:', err); });
}

function showToast(msg) {
  var existing = document.querySelector('.toast-notification');
  if (existing) existing.remove();
  var toast = document.createElement('div');
  toast.className = 'toast-notification';
  toast.textContent = msg;
  document.body.appendChild(toast);
  setTimeout(function() { toast.classList.add('show'); }, 10);
  setTimeout(function() {
    toast.classList.remove('show');
    setTimeout(function() { toast.remove(); }, 300);
  }, 2000);
}

function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function() { location.reload(); });
}

function removeCartItem(key) {
  updateCartItem(key, 0);
}

// ============================================================
// AUTO-CATEGORIZATION ENGINE
// ============================================================
// This engine mirrors the Shopify Flow recipe logic.
// Use it client-side to preview categorization, or reference
// the detectCategory() logic when building Shopify Flow rules.
// ============================================================

window.TRENDFY = window.TRENDFY || {};

// Category config — mirrors settings_schema.json defaults
TRENDFY.categoryConfig = {
  beauty: {
    type: 'Beauty',
    keywords: 'beauty,cosmetics,skincare,makeup,moisturizer,serum,facial,lipstick,mascara,eyeliner,foundation,concealer,blush,nail polish,lotion,cream,shampoo,conditioner,hair care,body wash,sunscreen,perfume,cologne,deodorant,spa,wellness,organic skincare,anti-aging,face wash,toner,essence,eye cream,lip balm,brow,lashes,beauty tool,makeup brush,cosmetic bag,beauty kit'.split(','),
    label: 'Beauty & Personal Care'
  },
  home: {
    type: 'Home',
    keywords: 'home,living room,kitchen,bedroom,bathroom,decor,furniture,lighting,lamp,candle,rug,curtain,throw pillow,blanket,wall art,vase,planter,storage,organizer,shelf,table,chair,sofa,mirror,frame,clock,home decor,home accessory,kitchen tool,cookware,dinnerware,glassware,bath mat,towel,bedding,sheets,duvet,quilt,mattress,night light,wall lamp,table lamp,floor lamp,chandelier,scented candle,home fragrance,room spray,incense,essential oil diffuser'.split(','),
    label: 'Home & Living'
  },
  kitchen: {
    type: 'Kitchen',
    keywords: 'kitchen,cookware,cooking,baking,pots,pans,knife,cutting board,utensil,spatula,whisk,peeler,grater,measuring cup,mixing bowl,colander,strainer,kitchen tool,kitchen gadget,pepper mill,salt cellar,oil dispenser,kitchen scale,thermometer,timer,kitchen shears,garlic press,can opener,bottle opener,corkscrew,kitchen knife,chef knife,paring knife,bread knife,kitchen scissors,mandoline,vegetable chopper,spiralizer,kitchen torch,sous vide,kitchen thermometer,meat tenderizer,rolling pin,pastry brush,piping bag,cookie cutter,cake pan,muffin tin,baking sheet,loaf pan,pie dish,bundt pan,springform pan,roasting pan,baking dish,casserole,ramekin,souffle dish,kitchen textile,apron,oven mitt,pot holder,kitchen towel,dishtowel,placemat,coaster,tablecloth,napkin,dinner plate,salad plate,bowl,mug,cup,saucer,teacup,coffee mug,wine glass,tumbler,stemware,decanter,pitcher,carafe,teapot,coffee maker,french press,pour over,water bottle,lunch box,food storage,container,jar,canister,bread box,spice rack,knife block,cutting board,kitchen cart,kitchen rack,sink organizer,drying rack,trivet,serving platter,serving bowl,salad bowl,cheese board,charcuterie board,meat tenderizer,dough scraper,biscuit cutter,pie weights,kitchen timer'.split(','),
    label: 'Kitchen'
  },
  accessories: {
    type: 'Accessories',
    keywords: 'bag,handbag,tote,backpack,clutch,wallet,card holder,watch,wristwatch,jewelry,necklace,bracelet,earring,ring,anklet,brooch,pin,cufflink,sunglasses,eyewear,glasses,scarf,belt,hat,cap,beanie,gloves,mitts,umbrella,keychain,phone case,lanyard,headband,hair accessory,clip,barrette,tie,bow tie,fanny pack,crossbody bag,shoulder bag,shopper bag,luggage,suitcase,travel bag,duffle,tote bag,purse,coin purse,billfold,trifold wallet'.split(','),
    label: 'Accessories'
  },
  tech: {
    type: 'Tech',
    keywords: 'tech,electronic,gadget,smartphone,phone case,charger,cable,adapter,earphone,headphone,earbuds,speaker,bluetooth,wireless,smart watch,fitness tracker,laptop,tablet,ipad,kindle,keyboard,mouse,usb,power bank,battery,stand,holder,computer,monitor,webcam,microphone,drone,camera,lens,tripod,selfie stick,gaming,controller,virtual reality,smart home,smart plug,led strip,projector,printer,scanner,router,modem,wifi,hard drive,ssd,memory card,flash drive,sd card,hdmi,display port,docking station,hub,adapter converter,star projector,moon lamp,night light projector,smart bulb'.split(','),
    label: 'Tech & Electronics'
  },
  // fragrance: {
  //   type: 'Fragrance',
  //   keywords: 'fragrance,perfume,cologne,eau de parfum,eau de toilette,body spray,mist,rollerball,scent,aroma,oud,musk,floral,woody,citrus,fresh,oriental,gourmand,niche perfume,perfume oil,attar,itri,essential oil blend,home fragrance oil,reed diffuser,room spray,fragrance oil,perfume sample,scented oil,candle fragrance'.split(','),
  //   label: 'Fragrance'
  // }
};

TRENDFY.detectCategory = function(product) {
  var config = TRENDFY.categoryConfig;
  var type = (product.type || '').toLowerCase().trim();
  var text = [
    product.title || '',
    product.description || '',
    (product.tags || []).join(' ')
  ].join(' ').toLowerCase();

  var best = { handle: 'general', label: 'General', score: 0 };

  Object.keys(config).forEach(function(handle) {
    var cat = config[handle];
    var score = 0;

    // PRIMARY: product type match = 100
    if (type === cat.type.toLowerCase()) {
      score = 100;
    }

    // SECONDARY: keyword matches
    if (score < 100) {
      cat.keywords.forEach(function(kw) {
        kw = kw.trim().toLowerCase();
        if (kw && text.indexOf(kw) !== -1) {
          score += 10;
        }
      });
    }

    if (score > best.score) {
      best = { handle: handle, label: cat.label, score: score };
    }
  });

  return best;
};

// If the category config is embedded in the page, apply it
var embeddedConfig = document.querySelector('[data-category-config]');
if (embeddedConfig) {
  try {
    var parsed = JSON.parse(embeddedConfig.textContent);
    if (parsed) TRENDFY.categoryConfig = parsed;
  } catch(e) { /* use defaults */ }
}

// Scroll to top button
(function() {
  var btn = document.getElementById('scroll-top');
  if (!btn) return;
  function toggle() {
    if (window.pageYOffset > 400) {
      btn.classList.add('visible');
    } else {
      btn.classList.remove('visible');
    }
  }
  window.addEventListener('scroll', toggle, { passive: true });
  btn.addEventListener('click', function() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
  toggle();
})();
